<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="show"
      width="70%"
    >
      <v-card>
        <v-card-title
          class="headline pb-1"
          primary-title
        >
          PDF Report
        </v-card-title>

        <v-card-text class="pt-0">
          <iframe
            class="pdf-iframe"
            :src="pdfUrl"
            style="height: 60vh"
          >
          </iframe>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="closeDialog()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
export default {
  name: 'pdf-report-viewer',
  data () {
    return {
    }
  },

  props: [ 
    'show',
    'pdfUrl'
  ],

  methods: {
    closeDialog() {
      this.$emit('close-dialog')
    }
  }
}

</script>

<style>
.pdf-iframe {
  width: 100%;
}
</style>